import { render } from "./TutorialRoll.vue?vue&type=template&id=f7b4bf38&scoped=true"
import script from "./TutorialRoll.vue?vue&type=script&lang=js"
export * from "./TutorialRoll.vue?vue&type=script&lang=js"

import "./TutorialRoll.vue?vue&type=style&index=0&id=f7b4bf38&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7b4bf38"]])

export default __exports__